import {Fragment, useState} from "react";

import {ChromePicker} from "react-color";
import invert from "invert-color";
import { Chip, Popover } from "@mui/material";
import { grey } from "@mui/material/colors";


export default function VariableName({id, name, color, onColorChange}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Fragment>
      <Chip label={name}
            onClick={handleClick}
            size="small"
            style={{
              backgroundColor: color,
              color: invert(color, { black: grey[900], white: "#ffffff" }),}}/>
      <Popover  id={open ? id : undefined}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{vertical: 'bottom',horizontal: 'center',}}
                transformOrigin={{vertical: 'top',horizontal: 'center',}}>
        <ChromePicker color={color} onChangeComplete={({hex}) => onColorChange(hex)}/>
      </Popover>
    </Fragment>
  );
}
